export default __webpack_public_path__ + "static/mercure-95b33b2ce87b6e5eb27e155a6e2008ee.png";